export { type LocalizationContext } from '@stickerapp-org/athena/i18n';

export const defaultLanguage = 'en';

export type Market = {
  countryCode: string;
  defaultLanguage: string;
  extraLanguages: string[];
  domain: string;
  /** If a market is visible to end customers in links market selectors */
  visible: boolean;
  useNewCheckout?: boolean;
  useKameleoon?: boolean;
  flag: string;
};

export function getUrl(path: string, language: string, market: Market) {
  const url = new URL('https://' + market.domain!);
  let pathToUse = '/' + path.replace(/^\//, '');
  if (market.extraLanguages?.length) {
    pathToUse = '/' + language + pathToUse;
  }
  url.pathname = pathToUse;
  return url;
}
